import animations from './animations';
import colors from './colors';
import layout from './layout';
import mediaQueries from './media-queries';
import typography from './typography';

export default {
    animations,
    colors,
    layout,
    mediaQueries,
    typography,
};
